<template>
    <v-dialog
        v-model="getModalExcluirProduto"
        max-width="500px"
        transition="dialog-transition"
    >

    <v-card>
        <v-card-title>
            Excluir Produto
        </v-card-title>
        <v-card-text>
            <h3 align="center">Tem certeza que deseja excluir?</h3>
        </v-card-text>
    
        <v-card-actions>
            <v-btn outlined color="default" @click="setModalExcluirProduto(false)">Voltar</v-btn>
            <v-spacer></v-spacer>
            <v-btn outlined color="error" @click="excluirProduto(getProduto.id)">Sim</v-btn>
        </v-card-actions>
    </v-card>   
        
    </v-dialog>
</template>
<script>
    import {mapGetters, mapActions} from 'vuex'
    export default {
        computed: {
            ...mapGetters([
                'getProduto',
                'getModalExcluirProduto'
            ])
        },
        methods: {
            ...mapActions([
                'setModalExcluirProduto',
                'excluirProduto'
            ])
        },
    }
</script>